import styled from 'styled-components';

export const ProfileActionCardTitle = styled.h3`
  color: ${({ theme }) => theme.colorsInObjects.gray[900]};
  font-family: "Source Sans Pro";
  font-size: ${({ theme }) => theme.fontSize.l};
  font-weight: 400;
  margin-bottom: ${({ theme }) => theme.spacing.m};
`;

export const NotificationPreferencesWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.m};
  margin: ${({ theme }) => theme.spacing.m} 0;
  justify-content: space-between;
`;

export const PreferencesCheckboxWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const SwitchContainer = styled.div`
  width: 56px;
  height: 30px;
  background: ${props => (props.isOn ?  props.theme.colorsInObjects.mint[900] : 'grey')};
  border-radius: ${({ theme }) => theme.radius.l};
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
`;

export const Toggle = styled.div`
width: 24px;
height: 24px;
background: white;
border-radius: 50%;
position: absolute;
top: 3px;
left: ${props => (props.isOn ? '29px' : '3px')};
transition: left 0.3s;
`;

export const CheckboxesWrapper = styled.div`
margin-top: ${({ theme }) => theme.spacing.s};
margin-left: -${({ theme }) => theme.spacing.s};
`;

export const PreferencesMainContainer = styled.div``;

export const SkeletonLoaderNotificationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.m};
`;
